var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "WMSModal",
        size: "xl",
        "content-class": "menu-bg-blue-transparent-modal wms-modal",
        "body-class": "scroll-Container",
        "hide-footer": "",
        title: "Work Management System Reports",
        scrollable: "",
      },
      on: { show: _vm.loadAnsiProjects },
    },
    [
      _c(
        "div",
        [
          _c(
            "b-tabs",
            { attrs: { align: "center", pills: "", card: "" } },
            [
              _c(
                "b-tab",
                { attrs: { title: "Quality", active: "" } },
                [
                  _c(
                    "b-container",
                    [
                      _c(
                        "b-row",
                        { attrs: { "align-v": "center" } },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "col-md-6 offset-md-3 align-self-center",
                            },
                            [
                              _c(
                                "b-form-select",
                                {
                                  on: {
                                    change: function ($event) {
                                      return _vm.getSelsets($event)
                                    },
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "first",
                                      fn: function () {
                                        return [
                                          _c(
                                            "b-form-select-option",
                                            {
                                              attrs: {
                                                value: null,
                                                disabled: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Select Customer *\n                  "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                  model: {
                                    value: _vm.selectedANSI,
                                    callback: function ($$v) {
                                      _vm.selectedANSI = $$v
                                    },
                                    expression: "selectedANSI",
                                  },
                                },
                                [
                                  _vm._v(" "),
                                  _vm._l(_vm.customers, function (customer) {
                                    return _c(
                                      "b-form-select-option",
                                      {
                                        key: customer.id,
                                        attrs: { value: customer },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              customer.name.substring(
                                                0,
                                                customer.name.length - 4
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    )
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.selsetList
                        ? _c(
                            "b-row",
                            {
                              staticClass: "py-4",
                              attrs: { "align-v": "center" },
                              on: {
                                change: function ($event) {
                                  return _vm.getReport(_vm.selectedSelset)
                                },
                              },
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "col-md-6 offset-md-3 align-self-center",
                                },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "first",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "b-form-select-option",
                                                  {
                                                    attrs: {
                                                      value: null,
                                                      disabled: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    Select Selset *\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        2107435938
                                      ),
                                      model: {
                                        value: _vm.selectedSelset,
                                        callback: function ($$v) {
                                          _vm.selectedSelset = $$v
                                        },
                                        expression: "selectedSelset",
                                      },
                                    },
                                    [
                                      _vm._v(" "),
                                      _vm._l(_vm.selsetList, function (selset) {
                                        return _c(
                                          "b-form-select-option",
                                          {
                                            key: selset.id,
                                            attrs: { value: selset },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(selset.selset) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      }),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.reportRows.length > 0
                    ? _c("h5", [
                        _vm._v("PART NUMBER : " + _vm._s(_vm.partNumber)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedSelset
                    ? _c("vue-bootstrap4-table", {
                        attrs: {
                          rows: _vm.reportRows,
                          columns: _vm.reportColumns,
                          config: _vm.config,
                          classes: _vm.classes,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }